let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eYAf0")).then(() => parcelRequire('dEERs'));